
import { Grid, Container} from '@mui/material';
import Footer from 'src/components/Footer';
import CreateEdit from './CreateEdit';
import { useState,useEffect } from 'react';
import SnackbarAlert from '../common/SnackbarAlert';
import EndoresementSubTypeList from './EndoresementSubTypeList';
import { checkPermission } from '../../utils/permission';
import NoPermissionContent from '../common/NoPermissionContent';
import loader from '../common/loader.gif';



function EndoresementSubType() {
  const [showCreateEdit, setShowCreateEdit] = useState(false);
  const [EndoresementSubTypeEditDatas, setEndoresementSubTypeEditDatas] = useState();
  const [editStatus, setEditStatus] = useState(false);
  const [EndoresementSubTypeViewPermission, setEndoresementSubTypeViewPermission] = useState(false);
  const [isLoading, setLoading] = useState(true);

  const [showSnackBarAlert, setShowSnackBarAlert] = useState({
    status: false,
    type: 'success',
    message: null
  });

  const showCreateEditForm = () => {
    setShowCreateEdit(true);
  };
  const closeCreateEditForm = (status) => {
    setEditStatus(false);
    setEndoresementSubTypeEditDatas(null);
    setShowCreateEdit(false);

    if (status === true) {
      setShowSnackBarAlert({
        status: true,
        type: 'success',
        message: editStatus ? 'Endorsement updated' : 'Endorsement saved'
      });
    }
  };

  const editDatas = (editData) => {
    setEditStatus(true);
    setEndoresementSubTypeEditDatas(editData);
    setShowCreateEdit(true);
  };

  const handleSnackbarClose = () => {
    setShowSnackBarAlert({ status: false, type: null, message: null });
  };

  useEffect(() => {
    checkRolePermission();
    
  }, []);

  const checkRolePermission = async () => {
    await checkPermission('EndorsementSubTypes', 'view').then((permission) => {
      setEndoresementSubTypeViewPermission(permission);
      setLoading(false);
    });
  };

  return (
    <>
      <SnackbarAlert
        showSnackBarAlert={showSnackBarAlert}
        handleSnackbarClose={handleSnackbarClose}
      />

      {showCreateEdit ? (
        <CreateEdit
          closeCreateEditForm={closeCreateEditForm}
          EndoresementSubTypeEditDatas={EndoresementSubTypeEditDatas}
          editStatus={editStatus}
        />
      ) : (
        <>
          <Container maxWidth="lg">
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="stretch"
              spacing={3}
            >
              <Grid item xs={12} className='ListContainer'>
                {EndoresementSubTypeViewPermission?(  <EndoresementSubTypeList
                  editDatas={editDatas}
                  showCreateEditForm={showCreateEditForm}
                /> ) : (
                  isLoading ? (

                    <img
                      alt="loader"
                      src={loader}
                      className="loader"
                      width={100}
                      height={100}
                    />

                  ) : (
                 <NoPermissionContent/>
                  )
                )}
              
              </Grid>
            </Grid>
          </Container>
        </>
      )}
      <Footer />
    </>
  );
}

export default EndoresementSubType;
